import _ from 'lodash';

import * as types from 'PointOfSale/modules/queue/state/types';
import { QueueStatusEnum } from 'PointOfSale/modules/common/constants';
import { SET_AUTOSERVE_ON_OFF } from 'PointOfSale/modules/servingOptions/state/types';
import { UPDATE_STUDENT } from 'PointOfSale/state/types';

export const INITIAL_STATE = {
  queue: [],
  queueStatus: QueueStatusEnum.OFF,
  queueStartedPreviously: false,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case UPDATE_STUDENT:
      return {
        ...state,
        queue: state.queue.map(student => {
          if (student.IdSeed === payload.idSeed) {
            return {
              ...student,
              ...payload.update,
            };
          }
          return student;
        }),
      };
    case types.ADD_TO_QUEUE:
      return {
        ...state,
        queue: [...state.queue, payload],
      };
    case types.ADD_TO_QUEUE_AND_SET_CURRENT:
      return {
        ...state,
        queue: payload,
      };

    case types.REMOVE_FROM_QUEUE: {
      const index = payload ? payload : 0;
      return {
        ...state,
        queue: state.queue.filter((_, i) => i !== index),
      };
    }
    case types.RESET_QUEUE:
      return {
        ...state,
        queue: [],
      };
    case SET_AUTOSERVE_ON_OFF: {
      return {
        ...state,
        queueStartedPreviously: payload,
      };
    }

    case types.CHANGE_QUEUE_STATUS: {
      let queueStartedPreviously = state.queueStartedPreviously;
      if (!state.queueStartedPreviously) {
        queueStartedPreviously = payload === QueueStatusEnum.ON;
      }
      return {
        ...state,
        queueStatus: payload,
        queueStartedPreviously,
      };
    }

    case types.SHUFFLE_QUEUE: {
      const pulled = _.pullAt(state.queue, payload);
      return {
        ...state,
        queue: _.concat(pulled, state.queue),
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/queue/state/reducer.js